import { useLang } from "../context/LanguageContext";
import { SITE } from "../data/content";
import SocialIcons from "./SocialIcons";
import lev1 from "../assets/parallax/1.png";
import lev2 from "../assets/parallax/2.png";
import lev3 from "../assets/parallax/3.png";
import lev4 from "../assets/parallax/4.png";
import lev5 from "../assets/parallax/5.png";
import lev6 from "../assets/parallax/6.png";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/4346cc9a-d2c4-4d4a-b5ca-73930d1d6354/images/5d81ccc331b4625dff9afd1692a2ef6837dee5f62ed91b73f17a338384534e3d.png";

const PORTRAIT_PLACEHOLDER =
  "https://customer-assets.emergentagent.com/job_levanta-preview/artifacts/zkw3avpa_Screenshot_2024-10-30-10-30-26-38_1c337646f29875672b5a61192b9010f9.jpg";

export default function Hero() {
  const { t } = useLang();

  return (
    <section
      className="relative min-h-screen flex items-center overflow-hidden paper-grain watercolor-wash"
      data-testid="hero-section"
    >
      <div
        className="lev-bg"
        aria-hidden="true"
        style={{
          "--lev-1": `url(${lev1})`,
          "--lev-2": `url(${lev2})`,
          "--lev-3": `url(${lev3})`,
          "--lev-4": `url(${lev4})`,
          "--lev-5": `url(${lev5})`,
          "--lev-6": `url(${lev6})`,
        }}
      >
        <div className="lev-scene">
          <div className="lev-layer lev-l6" />
          <div className="lev-layer lev-l5" />
          <div className="lev-layer lev-l4" />
          <div className="lev-layer lev-l3" />
          <div className="lev-layer lev-l2" />
          <div className="lev-layer lev-l1" />
        </div>
      </div>
      <div
        className="absolute inset-0 bg-gradient-to-b from-ink/10 via-transparent to-ink pointer-events-none"
        aria-hidden="true"
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 pt-32 pb-24 w-full">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7 animate-fade-up">
            <p className="chapter-num mb-6" data-testid="hero-eyebrow">
              {t("I don't have dreams. I have goals.", "אין לי חלומות. יש לי מטרות.")}
            </p>
            <h1
              className="font-serif text-6xl sm:text-7xl lg:text-8xl font-light tracking-tight leading-[0.95] text-parchment mb-8"
              data-testid="hero-name"
            >
              {t(SITE.name.en, SITE.name.he)}
              <span className="text-four-yellow">.</span>
            </h1>
            <div className="brush-divider" />
            <p
              className="font-serif italic text-2xl sm:text-3xl lg:text-4xl text-parchment-warm font-light leading-snug max-w-2xl mb-6"
              data-testid="hero-subtitle"
            >
              {t(SITE.subtitle.en, SITE.subtitle.he)}
            </p>
            <p className="text-base sm:text-lg text-parchment-dusk max-w-xl mb-10 leading-relaxed">
              &nbsp;
            </p>
            <SocialIcons testIdPrefix="hero-social" />
          </div>

          <div className="lg:col-span-5 flex justify-center animate-fade-in">
            <div className="relative">
              <div
                className="ink-circle relative overflow-hidden"
                style={{ width: "min(420px, 80vw)", height: "min(420px, 80vw)" }}
                data-testid="hero-portrait"
              >
                <img
                  src={PORTRAIT_PLACEHOLDER}
                  alt=""
                  className="absolute inset-3 w-[calc(100%-1.5rem)] h-[calc(100%-1.5rem)] object-cover rounded-full"
                  style={{ filter: "grayscale(20%) contrast(1.05)" }}
                />
              </div>
            </div>
          </div>
        </div>

        <div
          className="absolute bottom-8 inset-x-0 mx-auto w-fit text-center text-[10px] tracking-[0.4em] uppercase text-parchment-dusk animate-fade-in"
          data-testid="hero-scroll-cue"
        >
          {t("scroll", "גלול")}
          <div className="mx-auto mt-2 h-10 w-px bg-parchment-dusk/60" />
        </div>
      </div>
    </section>
  );
}
